/**
 * The code between MixinRestore and the MixinTemplate is almost identical. When making change to one, consider other file as well.
 */
import {useConnectionsStore} from "@/stores/ConnectionsStore";
import axios from "axios";

const templatePhpFile = 'template.php';

export default {

    methods: {

        async templateLoadAllTemplates() {

            let params = {};

            const connectionsStore = useConnectionsStore()

            params.currentConnection = connectionsStore.getCurrentConnection();
            params.operation = 'get_all_templates';

            return await axios.get(templatePhpFile, {
                params
            }).then((response) => {
                return response.data

            }).catch((error) => {
                // TODO: Log error
                console.log(error)
                return false
            })
        },

        async templateProcessLoadTemplate(chosenTemplate) {

            let params = {};

            const connectionsStore = useConnectionsStore()

            params.currentConnection = connectionsStore.getCurrentConnection();
            // params.operation = 'load_template';
            params.operation = 'load_template_from_centralised_server';
            params.chosenTemplate = chosenTemplate;

            return await axios.get(templatePhpFile, {
                params
            }).then((response) => {
                return response.data

            }).catch((error) => {
                // TODO: Log error
                console.log(error)
                return false
            })

        }
    }

}
